import { useEffect, useState } from 'react';
import { Dropdown, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { FaHouseUser, FaInfoCircle } from 'react-icons/fa';
import { MdHelpOutline, MdLogout, MdSettings } from 'react-icons/md';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../../AuthProvider';
import { getHRHelpMessages } from '../AdminDashboardpages/adminHelp';
import './HrDashboard.css';
import HrLeftSide from './HrLeftSide';

const DasboardNavbar = ({ user, isSidebarOpen, toggleSidebar }) => {
    const location = useLocation();
    // Initialize state with defaults
    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userId, setUserId] = useState();
    const [companyName, setCompanyName] = useState('');

    useEffect(() => {
        // Get user data from cookies
        const getCookie = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        };

        // Try to get company name from cookies first
        const userCookie = getCookie('user');
        if (userCookie) {
            try {
                const userData = JSON.parse(userCookie);
                if (userData.companyName) {
                    setCompanyName(userData.companyName);
                }
                setUserId(userData.userId);
            } catch (error) {
            }
        }

        // If not in cookies, try localStorage
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser?.companyName) {
            setCompanyName(storedUser.companyName);
        }

        // If user prop is available, use it, else fallback to location.state
        if (user) {
            setUserName(user.userName || '');  // Set userName from user prop
            setUserEmail(user.userEmail || '');      // Set userId from user prop
            setUserId(user.userId);
        } else if (location.state) {
            // If user prop is not available, fallback to location.state
            setUserName(location.state?.userName || '');
            setUserEmail(location.state?.userEmail || '');
            setUserId(location.state?.userId);
        }
    }, [user, location.state]);  // Effect depends on user and location.state 

    useEffect(() => {
        const storedUserName = localStorage.getItem(`userName_${userEmail}`);
        if (storedUserName) {
            setUserName(storedUserName);
        }
    }, [userEmail]);

    const convertToUpperCase = (str) => {
        return String(str).toUpperCase();
    };

    const getInitials = (name) => {
        const trimmedName = name.trim();
        const nameParts = trimmedName.split(' ');
        if (nameParts.length > 1) {

            return convertToUpperCase(nameParts[0][0] + nameParts[1][0]);
        } else {

            return convertToUpperCase(nameParts[0][0] + nameParts[0][1]);
        }
    };
    const initials = getInitials(userName);
    const toggleFullScreen = () => {
        if (document.fullscreenEnabled) {
            if (!document.fullscreenElement) document.documentElement.requestFullscreen();
            else document.exitFullscreen();
        }
    };

    const { logout } = useAuth(); // Get logout function from context
    const clearCookies = () => {
        const domain = window.location.hostname === 'localhost' ? 'localhost' : 'jobbox.one';
        document.cookie = `user=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
        document.cookie = `token=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    };
    const handleLogout = () => {
        Swal.fire({
            title: 'Are you sure you want to logout?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, logout!'
        }).then((result) => {
            if (result.isConfirmed) {
                clearCookies(); // Clear cookies
                logout(); // Call the logout function
                // Clear user data from localStorage
                localStorage.clear(); // Clear all local storage data
                // Redirect to the home page
                const redirectUrl = window.location.hostname === 'localhost'
                    ? 'http://localhost:3001' // Redirect to localhost for development
                    : 'https://jobbox.one'; // Redirect to production URL

                // Redirect to the determined URL
                window.location.href = redirectUrl;
            }
        });
    };
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);

    // Update the state on screen resize
    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth < 1200);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [helpMessage, setHelpMessage] = useState('');

    useEffect(() => {
        // Get the help message based on the current path
        const message = getHRHelpMessages(location.pathname);
        setHelpMessage(message); // Set the help message
    }, [location.pathname]); // Re-run when path changes
    return (
        <div className="main-header" style={{ position: 'fixed' }}>
            <Link to="/" style={{ textDecoration: 'none' }}>
                <div className="dashboard-navbar-logo">
                    {isSmallScreen ? (
                        <img
                            src="/jb_temp_logo.png"
                            alt="Temporary Logo"
                            style={{ height: '70px', width: '70px' }}
                        />
                    ) : (
                        <img
                            src="/jb_logo.png"
                            alt="Logo"
                            style={{ height: '60px', width: '150px' }}
                        />
                    )}
                </div></Link>

            <div className="menu-toggle" style={{ marginLeft: '50px' }} onClick={toggleSidebar}>
                <div />
                <div />
                <div />
            </div>
            {isSidebarOpen && (
                <HrLeftSide user={{ userName, userEmail, userId }} isOpen={isSidebarOpen} />
            )}

            <div className="m-auto" />

            <div className="header-part-right">

                {/* Visible on large screens */}
                <span className="d-none d-lg-block">
                    <Row><strong>{companyName.toUpperCase()} Jobbox </strong></Row>
                    <Row><strong>JobboxId:{companyName.toLowerCase().replaceAll(" ", "")}@jobbox.one</strong></Row>
                </span>

                {/* Only visible on small screens */}
                <div className="d-block d-lg-none">
                    <OverlayTrigger
                        trigger="click"
                        placement="bottom"
                        overlay={
                            <Popover
                                id="company-info-popover"
                                style={{ minWidth: '250px', maxWidth: '300px' }} // Adjust width here
                            >
                                <Popover.Body style={{ marginTop: '5px', padding: '10px', wordBreak: 'break-word' }}>
                                    <div>
                                        <strong>{companyName.toUpperCase()} Jobbox</strong><br />
                                        <strong>
                                            JobboxId: {companyName.toLowerCase().replaceAll(" ", "")}@jobbox.one
                                        </strong>
                                    </div>
                                </Popover.Body>
                            </Popover>
                        }
                        rootClose
                    >
                        <span className="cursor-pointer p-2 d-inline-block">
                            <FaInfoCircle size={24} />
                        </span>
                    </OverlayTrigger>


                </div>

                {/* FULLSCREEN HANDLER (Only Icon) */}
                <i
                    datafullscreen="true"
                    className="i-Full-Screen header-icon d-none d-sm-inline-block"
                    onClick={toggleFullScreen}
                />

                {/* NOTIFICATION MENU BAR (Only Icon) */}
                <div className="notification-icon-container">
                    <span className="badge bg-primary cursor-pointer"></span>
                    <i className="i-Bell text-muted header-icon" />
                </div>

                {/* USER PROFILE MENU BAR (Only Icon) */}
                <div className="user">
                    <Dropdown className="ml-2">
                        <Dropdown.Toggle as="span" className="toggle-hidden">
                            <div className="initials-placeholder">
                                {initials}
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="mt-3">
                            <Dropdown.Item as={Link} to="/settings">
                                <MdSettings style={{ marginRight: '10px' }} />Settings
                            </Dropdown.Item>
                            <Dropdown.Item as="button" onClick={handleLogout}>
                                <MdLogout style={{ marginRight: '10px' }} /> Logout
                            </Dropdown.Item>
                            <Dropdown.Item as="button" onClick={() => {
                                const redirectUrl = window.location.hostname === 'localhost'
                                    ? 'http://localhost:3001' // Redirect to localhost for development
                                    : 'https://jobbox.one'; // Redirect to production URL

                                // Redirect to the determined URL
                                window.location.href = redirectUrl;
                            }}>
                                <FaHouseUser style={{ marginRight: '10px' }} /> Home
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                {/* Help Dropdown */}
                <div className="help-icon-container col px-3">
                    <Dropdown className="ml-2">
                        <Dropdown.Toggle as="div" id="dropdownHelp" className="toggle-hidden cursor-pointer">
                            <MdHelpOutline style={{ fontSize: '35px' }} /> {/* Help Icon */}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="mt-3" style={{ width: '300px' }}>
                            {/* Display the help message if it's available */}
                            <Dropdown.ItemText style={{ padding: '10px' }}>
                                {helpMessage || 'No specific help message available for this page.'}
                            </Dropdown.ItemText>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </div>

    )
}

export default DasboardNavbar
